<app-header
  *ngIf="!loading"
  [isExternal]="true"
  [logo]="logo"
  [color]="color"
></app-header>

<ng-container *ngIf="!loading; else spinner">

  <!-- Videochat training session -->
  <app-assistance-view
    *ngIf="!error; else errorMessage"
    [assistance]="assistance"
    [assistanceType]="AssistanceType.EXTERNAL_MAINTENANCE"
    [userName]="expertFirstName"
    [userSurname]="expertLastName"
    [userId]="companyId"
    [useCustomName]="true"
    [canEditScene]="true"
    [canClose]="true"
    (onClosed)="onClosed()"
  ></app-assistance-view>

</ng-container>

<ng-template #spinner>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>

<ng-template #errorMessage>
  <h1 class="error">An error has occurred. Try again</h1>
</ng-template>
